var _style, _path, _line, _line2, _line3, _line4, _line5, _path2, _line6, _line7, _line8, _line9, _line0, _path3, _line1, _line10, _line11, _line12, _line13, _path4, _circle, _path5, _line14, _line15, _line16, _line17, _line18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleCircleFlare2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.62,6.86V3.98c3.85,2.32,7.08,5.55,9.4,9.4h-2.86"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 30,
    y1: 1.5,
    x2: 30,
    y2: 4.35
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 46.62,
    y1: 6.86,
    x2: 44.96,
    y2: 9.17
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 53.14,
    y1: 13.38,
    x2: 50.83,
    y2: 15.04
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 46.62,
    y1: 3.98,
    x2: 38.92,
    y2: 2.92
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 56.02,
    y1: 13.38,
    x2: 57.08,
    y2: 21.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.86,13.38H3.98c2.32-3.85,5.55-7.08,9.4-9.4v2.86"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1.5,
    y1: 30,
    x2: 4.35,
    y2: 30
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6.86,
    y1: 13.38,
    x2: 9.17,
    y2: 15.04
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13.38,
    y1: 6.86,
    x2: 15.04,
    y2: 9.17
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3.98,
    y1: 13.38,
    x2: 2.92,
    y2: 21.08
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13.38,
    y1: 3.98,
    x2: 21.08,
    y2: 2.92
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.38,53.14v2.88c-3.85-2.32-7.08-5.55-9.4-9.4h2.86"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 30,
    y1: 58.5,
    x2: 30,
    y2: 55.65
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13.38,
    y1: 53.14,
    x2: 15.04,
    y2: 50.83
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6.86,
    y1: 46.62,
    x2: 9.17,
    y2: 44.96
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13.38,
    y1: 56.02,
    x2: 21.08,
    y2: 57.08
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3.98,
    y1: 46.62,
    x2: 2.92,
    y2: 38.92
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.14,46.62h2.88c-2.32,3.85-5.55,7.08-9.4,9.4v-2.86"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 30,
    cy: 30,
    r: 28.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.35,30C4.35,15.84,15.84,4.35,30,4.35S55.65,15.84,55.65,30S44.16,55.65,30,55.65S4.35,44.16,4.35,30z"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 58.5,
    y1: 30,
    x2: 55.65,
    y2: 30
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 53.14,
    y1: 46.62,
    x2: 50.83,
    y2: 44.96
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 46.62,
    y1: 53.14,
    x2: 44.96,
    y2: 50.83
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 56.02,
    y1: 46.62,
    x2: 57.08,
    y2: 38.92
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 46.62,
    y1: 56.02,
    x2: 38.92,
    y2: 57.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCircleFlare2);
export default __webpack_public_path__ + "static/media/double_circle_flare_2.20b9ef4b4563b2aacdd4a0971bf31f35.svg";
export { ForwardRef as ReactComponent };